//////////////////
// IMPORTS
//////////////////
// schema
import * as ISchema from "@schema";
// libraries
import * as React from "react";
import { createFragmentContainer } from "react-relay";
// suggestion-action-decline imports
import { IActionProps } from "../SuggestionAction.d";
import { fragments } from "./SuggestionActionDecline.gql";
import { CardButton } from "@components/card";
import { ArrowForward } from "@material-ui/icons";
type IProps = IActionProps<ISchema.ISuggestionActionDeclinePayload>;

//////////////////
// COMPONENT
//////////////////
class SuggestionActionDeclineCmpt extends React.Component<IProps> {
  private decline = () => {
    const { actionCallback } = this.props;

    if (actionCallback) {
      actionCallback();
    }
  };

  public render() {
    const { label } = this.props;
    return <CardButton flat icon={<ArrowForward />} onClick={this.decline} label={label} />;
  }
}

//////////////////
// RELAY
//////////////////
export const SuggestionActionDecline = createFragmentContainer<IProps>(
  SuggestionActionDeclineCmpt,
  fragments,
);
